import { Component } from 'react';
import { notificationController } from '@app/controllers/notificationController';
import hitachi_logo_inspire from 'assets/logo_white.jpg';
import { Col, Row, Spin } from 'antd';
import SafetyLayout from './SafetyLayout';
import QualityLayout from './QualityLayout';
import DeliveryLayout from './DeliveryLayout';
import ProductiveLayout from './ProductiveLayout';

import SafetyLayoutFac from '../fac/SafetyLayout';
import SafetyLayoutInt from '../int/SafetyLayout';
import SafetyLayoutIqc from '../iqc/SafetyLayout';
import SafetyLayoutSpa from '../spa/SafetyLayout';
import SafetyLayoutCbm from '../cbm/SafetyLayout';
import SafetyLayoutWh from '../wh/SafetyLayout';

import UtilityLayoutFac from '../fac/UtilityLayout';
import QualityLayoutInt from '../int/QualityLayout';
import QualityLayoutIqc from '../iqc/QualityLayout';
import QualityLayoutSpa from '../spa/QualityLayout';
import QualityLayoutCbm from '../cbm/QualityLayout';
import QualityLayoutWh from '../wh/QualityLayout';

import MachineLayoutFac from '../fac/MachineLayout';
import DeliveryLayoutInt from '../int/DeliveryLayout';
import DeliveryLayoutIqc from '../iqc/DeliveryLayout';
import DeliveryLayoutSpa from '../spa/DeliveryLayout';
import DeliveryLayoutCbm from '../cbm/DeliveryLayout';
import DeliveryLayoutWh from '../wh/DeliveryLayout';

import OthersLayoutFac from '../fac/OthersLayout';
import ProductiveLayoutInt from '../int/ProductiveLayout';
import ProductiveLayoutIqc from '../iqc/ProductiveLayout';
import ProductiveLayoutSpa from '../spa/ProductiveLayout';
import ProductiveLayoutCbm from '../cbm/ProductiveLayout';
import ProductiveLayoutWh from '../wh/ProductiveLayout';

import * as S from '../../tables/Tables/Tables.styles';
import * as Sbutton from '@app/components/apps/newsFeed/NewsFilter/NewsFilter.styles';

import * as H from '@app/components/header/Header.styles';
import { DatePicker } from 'antd';

import '@app/components/sqdp/all_factory/styles/sqdp.css';
import { elements } from './_data_safety_layout';

import { getStatistic as getStatisticFac } from '@app/api/fac/issue.api';
import { getStatistic as getStatisticIqc } from '@app/api/iqc/issue.api';
import { getStatistic as getStatisticInt } from '@app/api/int/issue.api';
import { getStatistic as getStatisticSpa } from '@app/api/spa/issue.api';
import { getStatistic as getStatisticCbm } from '@app/api/cbm/issue.api';
import { getStatistic as getStatisticWh } from '@app/api/wh/issue.api';
import dayjs from 'dayjs';
import { Button } from 'antd';
import { getSetting } from '@app/api/settings.api';
import {
  setDayColorError,
  setDayColorGood,
  setDayColorWarn,
  setLogoTitle,
  setLogoUrl,
  setSettingId,
} from '@app/services/localStorage.service';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { BarAllIssueStatusChart } from '@app/components/charts/BarAnimationDelayChart/allIssue/BarIssueStatusChart';
import { ProfileDropdown } from '@app/components/header/components/profileDropdown/ProfileDropdown/ProfileDropdown';
import { SettingsDropdown } from '@app/components/header/components/settingsDropdown/SettingsDropdown';
import { HeaderFullscreen } from '@app/components/header/components/HeaderFullscreen/HeaderFullscreen';

const monthFormat = 'MM/YYYY';
const listFactory = ['SPACER', 'INTERRUPTER', 'CBM', 'IQC', 'WARE HOUSE', 'FACILITY'];
const listFactoryPlant = ['SPACER', 'INTERRUPTER', 'CBM'];
const listFactoryShareFunction = ['IQC', 'WARE HOUSE', 'FACILITY'];
const issueTypes = {
  safety: 'SAFETY',
  quality: 'QUALITY',
  delivery: 'DELIVERY',
  productivity: 'PRODUCTTIVITY',
};

class SQDPAll extends Component {
  state = {
    clickShowIssue: false,
    element: {},
    lastClickedElement: 0,
    lastGroupClicked: 0,
    currentStatistics: {},
    dataInMonthFac: null,
    dataInMonthInt: null,
    dataInMonthIqc: null,
    dataInMonthCbm: null,
    dataInMonthWh: null,
    dataInMonthSpa: null,
    selectedMonth: dayjs().unix() * 1000,
    selectedProcess: '',
    processList: null,
    showFullIssue: '',
    filterMonth: null,
  };

  showFullSafety = (num, issueGroup) => {
    let group = issueTypes.safety;
    if (issueGroup == 2) {
      group = issueTypes.quality;
    }
    if (issueGroup == 3) {
      group = issueTypes.delivery;
    }
    if (issueGroup == 4) {
      group = issueTypes.productivity;
    }
    this.setState({
      showFullIssue: group,
      lastClickedElement: num,
      lastGroupClicked: issueGroup,
    });
  };

  handleOpenFactory = (fac) => {
    let factoryUrl = '';
    switch (fac) {
      case listFactory[0]:
        factoryUrl = '/spa';
        break;
      case listFactory[1]:
        factoryUrl = '/int';
        break;
      case listFactory[2]:
        factoryUrl = '/cbm';
        break;
      case listFactory[3]:
        factoryUrl = '/iqc';
        break;
      case listFactory[4]:
        factoryUrl = '/wh';
        break;
      case listFactory[5]:
        factoryUrl = 'fac/issue';
        break;
      default:
        factoryUrl = '/spa';
    }

    window.open(factoryUrl);
  };

  showIssueInfo = (num, issueGroup, fac) => {
    console.log(this.state.showFullIssue, fac);
    this.setState({
      clickShowIssue: true,
      element: elements[num],
    });
    this.state.lastClickedElement = num;
    this.state.lastGroupClicked = issueGroup;

    if (!this.state.showFullIssue) return;
    let selectedMonth = dayjs(this.state.selectedMonth).get('month');
    let selectedYear = dayjs(this.state.selectedMonth).get('year');
    //  console.log('=============== %d, %d, %d, %d', num, selectedMonth,selectedYear, issueGroup);

    //link to issue query
    //get date
    let date = dayjs().set('year', selectedYear).set('month', selectedMonth).set('date', num);
    if (date.isAfter(dayjs())) {
      notificationController.info({ message: this.props.useTranslation('cbm.common.nodataforthistime') });
      return;
    }
    let group = 'safety';
    if (issueGroup == 2) {
      fac === 'fac' ? (group = 'utility') : (group = 'quality');
    }
    if (issueGroup == 3) {
      fac === 'fac' ? (group = 'machine') : (group = 'delivery');
    }
    if (issueGroup == 4) {
      fac === 'fac' ? (group = 'other') : (group = 'productivity');
    }
    window.open(
      `/${fac}/issue/query?` +
        ('group=' + group + '&') +
        'createdAtMin=' +
        date.startOf('day') +
        '&createdAtMax=' +
        date.endOf('day'),
      '_blank',
    );
  };

  componentWillMount = () => {
    this.getGembaStatistic();
    getSetting('int').then((respSetting) => {
      if (respSetting?.data) {
        const data = respSetting.data;
        setSettingId(data.id, 'int');
        setLogoTitle(data.logoTitle, 'int');
        setLogoUrl(data.logoImageUrl, 'int');
        setDayColorGood(data.dayColorGood, 'int');
        setDayColorWarn(data.dayColorWarn, 'int');
        setDayColorError(data.dayColorError, 'int');
      }
    });
    getSetting('iqc').then((respSetting) => {
      if (respSetting.data) {
        const data = respSetting.data;
        setSettingId(data.id, 'iqc');
        setLogoTitle(data.logoTitle, 'iqc');
        setLogoUrl(data.logoImageUrl, 'iqc');
        setDayColorGood(data.dayColorGood, 'iqc');
        setDayColorWarn(data.dayColorWarn, 'iqc');
        setDayColorError(data.dayColorError, 'iqc');
      }
    });
    getSetting('wh').then((respSetting) => {
      if (respSetting.data) {
        const data = respSetting.data;
        setSettingId(data.id, 'wh');
        setLogoTitle(data.logoTitle, 'wh');
        setLogoUrl(data.logoImageUrl, 'wh');
        setDayColorGood(data.dayColorGood, 'wh');
        setDayColorWarn(data.dayColorWarn, 'wh');
        setDayColorError(data.dayColorError, 'wh');
      }
    });
    getSetting('cbm').then((respSetting) => {
      if (respSetting.data) {
        const data = respSetting.data;
        setSettingId(data.id, 'cbm');
        setLogoTitle(data.logoTitle, 'cbm');
        setLogoUrl(data.logoImageUrl, 'cbm');
        setDayColorGood(data.dayColorGood, 'cbm');
        setDayColorWarn(data.dayColorWarn, 'cbm');
        setDayColorError(data.dayColorError, 'cbm');
      }
    });
    // getProcessList({})
    //   .then((response) => {
    //     if (response && response.data) {
    //       this.getGembaStatistic();
    //       this.setState({
    //         processList: response.data,
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };

  getGembaStatisticFac = (req) =>
    getStatisticFac(req)
      .then((response) => {
        if (response && response.data) {
          //tinh ngay nghi
          let indexNgayNghis = response.data
            .map((e, i) =>
              e.countSafetyTotal <= 0 &&
              e.countMachineTotal <= 0 &&
              e.countOtherIssueTotal <= 0 &&
              e.countUtilityTotal <= 0
                ? i
                : undefined,
            )
            .filter((x) => x !== undefined);
          if (this.state.selectedProcess) {
            req.processName = this.state.selectedProcess;
            getStatisticFac(req)
              .then((response2) => {
                // console.log('response2.data before ', response2.data)
                if (response2 && response2.data) {
                  // indexNgayNghis = response2.data.map((e,i) =>e.countSafetyTotal <=0 && e.countDeliveryTotal <=0 && e.countProductivityTotal <=0 && e.countQualityTotal <=0 ? i : undefined).filter(x => x!==undefined)
                  // console.log('indexNgayNghis response2.data ', indexNgayNghis, response2.data)

                  indexNgayNghis.forEach((index) => {
                    if (response2.data[index]) {
                      response2.data[index].isRestDay = true;
                    }
                  });
                  // console.log('response2.data after ', response2.data)
                  this.setState({
                    dataInMonthFac: response2.data,
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            indexNgayNghis.forEach((index) => {
              response.data[index].isRestDay = true;
            });
            this.setState({
              dataInMonthFac: response.data,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

  getGembaStatisticInt = (req) =>
    getStatisticInt(req)
      .then((response) => {
        if (response && response.data) {
          //tinh ngay nghi
          let indexNgayNghis = response.data
            .map((e, i) =>
              e.countSafetyTotal <= 0 &&
              e.countDeliveryTotal <= 0 &&
              e.countProductivityTotal <= 0 &&
              e.countQualityTotal <= 0
                ? i
                : undefined,
            )
            .filter((x) => x !== undefined);
          if (this.state.selectedProcess) {
            req.processName = this.state.selectedProcess;
            getStatisticInt(req)
              .then((response2) => {
                // console.log('response2.data before ', response2.data)
                if (response2 && response2.data) {
                  // indexNgayNghis = response2.data.map((e,i) =>e.countSafetyTotal <=0 && e.countDeliveryTotal <=0 && e.countProductivityTotal <=0 && e.countQualityTotal <=0 ? i : undefined).filter(x => x!==undefined)
                  // console.log('indexNgayNghis response2.data ', indexNgayNghis, response2.data)

                  indexNgayNghis.forEach((index) => {
                    if (response2.data[index]) {
                      response2.data[index].isRestDay = true;
                    }
                  });
                  // console.log('response2.data after ', response2.data)
                  this.setState({
                    dataInMonthInt: response2.data,
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            indexNgayNghis.forEach((index) => {
              response.data[index].isRestDay = true;
            });
            this.setState({
              dataInMonthInt: response.data,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

  getGembaStatisticIqc = (req) =>
    getStatisticIqc(req)
      .then((response) => {
        if (response && response.data) {
          //tinh ngay nghi
          let indexNgayNghis = response.data
            .map((e, i) =>
              e.countSafetyTotal <= 0 &&
              e.countDeliveryTotal <= 0 &&
              e.countProductivityTotal <= 0 &&
              e.countQualityTotal <= 0
                ? i
                : undefined,
            )
            .filter((x) => x !== undefined);

          if (this.state.selectedProcess) {
            req.processName = this.state.selectedProcess;
            getStatisticIqc(req)
              .then((response2) => {
                // console.log('response2.data before ', response2.data)
                if (response2 && response2.data) {
                  // indexNgayNghis = response2.data.map((e,i) =>e.countSafetyTotal <=0 && e.countDeliveryTotal <=0 && e.countProductivityTotal <=0 && e.countQualityTotal <=0 ? i : undefined).filter(x => x!==undefined)
                  // console.log('indexNgayNghis response2.data ', indexNgayNghis, response2.data)

                  indexNgayNghis.forEach((index) => {
                    if (response2.data[index]) {
                      response2.data[index].isRestDay = true;
                    }
                  });
                  // console.log('response2.data after ', response2.data)
                  this.setState({
                    dataInMonthIqc: response2.data,
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            indexNgayNghis.forEach((index) => {
              response.data[index].isRestDay = true;
            });
            this.setState({
              dataInMonthIqc: response.data,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

  getGembaStatisticCbm = (req) =>
    getStatisticCbm(req)
      .then((response) => {
        if (response && response.data) {
          //tinh ngay nghi
          let indexNgayNghis = response.data
            .map((e, i) =>
              e.countSafetyTotal <= 0 &&
              e.countDeliveryTotal <= 0 &&
              e.countProductivityTotal <= 0 &&
              e.countQualityTotal <= 0
                ? i
                : undefined,
            )
            .filter((x) => x !== undefined);

          if (this.state.selectedProcess) {
            req.processName = this.state.selectedProcess;
            getStatisticCbm(req)
              .then((response2) => {
                // console.log('response2.data before ', response2.data)
                if (response2 && response2.data) {
                  // indexNgayNghis = response2.data.map((e,i) =>e.countSafetyTotal <=0 && e.countDeliveryTotal <=0 && e.countProductivityTotal <=0 && e.countQualityTotal <=0 ? i : undefined).filter(x => x!==undefined)
                  // console.log('indexNgayNghis response2.data ', indexNgayNghis, response2.data)

                  indexNgayNghis.forEach((index) => {
                    if (response2.data[index]) {
                      response2.data[index].isRestDay = true;
                    }
                  });
                  // console.log('response2.data after ', response2.data)
                  this.setState({
                    dataInMonthCbm: response2.data,
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            indexNgayNghis.forEach((index) => {
              response.data[index].isRestDay = true;
            });
            this.setState({
              dataInMonthCbm: response.data,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

  getGembaStatisticWh = (req) =>
    getStatisticWh(req)
      .then((response) => {
        if (response && response.data) {
          //tinh ngay nghi
          let indexNgayNghis = response.data
            .map((e, i) =>
              e.countSafetyTotal <= 0 &&
              e.countDeliveryTotal <= 0 &&
              e.countProductivityTotal <= 0 &&
              e.countQualityTotal <= 0
                ? i
                : undefined,
            )
            .filter((x) => x !== undefined);

          if (this.state.selectedProcess) {
            req.processName = this.state.selectedProcess;
            getStatisticWh(req)
              .then((response2) => {
                // console.log('response2.data before ', response2.data)
                if (response2 && response2.data) {
                  // indexNgayNghis = response2.data.map((e,i) =>e.countSafetyTotal <=0 && e.countDeliveryTotal <=0 && e.countProductivityTotal <=0 && e.countQualityTotal <=0 ? i : undefined).filter(x => x!==undefined)
                  // console.log('indexNgayNghis response2.data ', indexNgayNghis, response2.data)

                  indexNgayNghis.forEach((index) => {
                    if (response2.data[index]) {
                      response2.data[index].isRestDay = true;
                    }
                  });
                  // console.log('response2.data after ', response2.data)
                  this.setState({
                    dataInMonthWh: response2.data,
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            indexNgayNghis.forEach((index) => {
              response.data[index].isRestDay = true;
            });
            this.setState({
              dataInMonthWh: response.data,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

  getGembaStatisticSpa = (req) =>
    getStatisticSpa(req)
      .then((response) => {
        if (response && response.data) {
          //tinh ngay nghi
          let indexNgayNghis = response.data
            .map((e, i) =>
              e.countSafetyTotal <= 0 &&
              e.countDeliveryTotal <= 0 &&
              e.countProductivityTotal <= 0 &&
              e.countQualityTotal <= 0
                ? i
                : undefined,
            )
            .filter((x) => x !== undefined);

          if (this.state.selectedProcess) {
            req.processName = this.state.selectedProcess;
            getStatisticSpa(req)
              .then((response2) => {
                // console.log('response2.data before ', response2.data)
                if (response2 && response2.data) {
                  // indexNgayNghis = response2.data.map((e,i) =>e.countSafetyTotal <=0 && e.countDeliveryTotal <=0 && e.countProductivityTotal <=0 && e.countQualityTotal <=0 ? i : undefined).filter(x => x!==undefined)
                  // console.log('indexNgayNghis response2.data ', indexNgayNghis, response2.data)

                  indexNgayNghis.forEach((index) => {
                    if (response2.data[index]) {
                      response2.data[index].isRestDay = true;
                    }
                  });
                  // console.log('response2.data after ', response2.data)
                  this.setState({
                    dataInMonthSpa: response2.data,
                  });
                }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            indexNgayNghis.forEach((index) => {
              response.data[index].isRestDay = true;
            });
            this.setState({
              dataInMonthSpa: response.data,
            });
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });

  getGembaStatistic = () => {
    console.log(
      'this.state.selectedMonth, this.state.selectedProcess ',
      this.state.selectedMonth,
      this.state.selectedProcess,
    );
    this.state.dataInMonthFac = null;
    this.setState({ filterMonth: this.state.selectedMonth });
    let selectedTime = dayjs(this.state.selectedMonth ? this.state.selectedMonth : new Date());
    let timeStartOfMonth = selectedTime.startOf('month').unix() * 1000;
    let timeEndOfMonth = selectedTime.endOf('month').unix() * 1000;

    let req = {
      createdAtMin: timeStartOfMonth,
      createdAtMax: timeEndOfMonth,
    };

    Promise.all([
      this.getGembaStatisticFac(req),
      this.getGembaStatisticIqc(req),
      this.getGembaStatisticInt(req),
      this.getGembaStatisticCbm(req),
      this.getGembaStatisticSpa(req),
      this.getGembaStatisticWh(req),
    ]);
  };
  // getProcesses = ()=>{

  // }
  onChangeSelectTime = (event) => {
    if (event) {
      this.setState({ selectedMonth: event.unix() * 1000 });
    } else {
      this.setState({ selectedMonth: dayjs().unix() * 1000 });
    }
  };

  onChangeSelectProcess = (event) => {
    this.setState({ selectedProcess: event });
  };

  conditionShowData = () =>
    this.state.dataInMonthFac &&
    this.state.dataInMonthIqc &&
    this.state.dataInMonthInt &&
    this.state.dataInMonthCbm &&
    this.state.dataInMonthWh &&
    this.state.dataInMonthSpa;

  render() {
    let t = this.props.useTranslation;

    const applyFilter = () => {
      this.getGembaStatistic();
    };

    return (
      <div
        className="dashboard"
        style={{
          width: '100%',
          height: this.state.showFullIssue || !this.conditionShowData() ? '100vh' : 'auto',
        }}
      >
        <Spin spinning={!this.conditionShowData()} style={{ height: '600px' }} size="large">
          <div style={{ backgroundColor: 'var(--layout-header-bg-color)' }}>
            {this.state.showFullIssue ? (
              <>
                <Row style={{ marginBottom: '-0.5rem', marginTop: '1.5rem', marginLeft: '1rem' }}>
                  <Col span={4}>
                    <Sbutton.BtnWrapper>
                      <Sbutton.Btn
                        onClick={() => this.setState({ showFullIssue: '' })}
                        type="primary"
                        style={{ width: '15vh' }}
                      >
                        {t('common.back')} <ArrowLeftOutlined />
                      </Sbutton.Btn>
                    </Sbutton.BtnWrapper>
                  </Col>
                  <Col span={20}>
                    <H.ProfileColumn $isTwoColumnsLayout={false} style={{ paddingRight: '1rem' }}>
                      <Row align="middle" justify="end" gutter={[10, 10]}>
                        <Col>
                          <Row gutter={[{ xxl: 10 }, { xxl: 10 }]}>
                            <Col>
                              <HeaderFullscreen />
                            </Col>
                            <Col>
                              <SettingsDropdown />
                            </Col>
                          </Row>
                        </Col>

                        <Col>
                          <ProfileDropdown />
                        </Col>
                        <Col style={{ marginLeft: 10 }}>
                          <img src={hitachi_logo_inspire} alt="Hitachi" height={60} />
                        </Col>
                      </Row>
                    </H.ProfileColumn>
                  </Col>
                </Row>
                <S.TablesWrapper>
                  <S.Card style={{ margin: '15px' }}>
                    <Row>
                      <Col span={3} style={{ display: 'flex', alignItems: 'center', paddingLeft: '15px' }}>
                        <h2>Plant</h2>
                      </Col>
                      <Col span={7}>
                        {this.state.showFullIssue === issueTypes.safety ? (
                          <SafetyLayoutSpa
                            factory={'spa'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthSpa}
                          ></SafetyLayoutSpa>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.quality ? (
                          <QualityLayoutSpa
                            factory={'spa'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthSpa}
                          ></QualityLayoutSpa>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.delivery ? (
                          <DeliveryLayoutSpa
                            factory={'spa'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthSpa}
                          ></DeliveryLayoutSpa>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.productivity ? (
                          <ProductiveLayoutSpa
                            factory={'spa'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthSpa}
                          ></ProductiveLayoutSpa>
                        ) : null}
                      </Col>
                      <Col span={7}>
                        {this.state.showFullIssue === issueTypes.safety ? (
                          <SafetyLayoutInt
                            factory={'int'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthInt}
                          ></SafetyLayoutInt>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.quality ? (
                          <QualityLayoutInt
                            factory={'int'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthInt}
                          ></QualityLayoutInt>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.delivery ? (
                          <DeliveryLayoutInt
                            factory={'int'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthInt}
                          ></DeliveryLayoutInt>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.productivity ? (
                          <ProductiveLayoutInt
                            factory={'int'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthInt}
                          ></ProductiveLayoutInt>
                        ) : null}
                      </Col>
                      <Col span={7}>
                        {this.state.showFullIssue === issueTypes.safety ? (
                          <SafetyLayoutCbm
                            factory={'cbm'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthCbm}
                          ></SafetyLayoutCbm>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.quality ? (
                          <QualityLayoutCbm
                            factory={'cbm'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthCbm}
                          ></QualityLayoutCbm>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.delivery ? (
                          <DeliveryLayoutCbm
                            factory={'cbm'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthCbm}
                          ></DeliveryLayoutCbm>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.productivity ? (
                          <ProductiveLayoutCbm
                            factory={'cbm'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthCbm}
                          ></ProductiveLayoutCbm>
                        ) : null}
                      </Col>
                    </Row>

                    <Row style={{ marginTop: '25px' }}>
                      <Col span={3}></Col>
                      {listFactoryPlant.map((val, key) => (
                        <>
                          <Col
                            key={key}
                            span={7}
                            style={
                              this.state.showFullIssue === issueTypes.productivity
                                ? { paddingLeft: '50px', textAlign: 'center' }
                                : { paddingLeft: '30px', paddingRight: '15px', fontSize: '15.5px', textAlign: 'center' }
                            }
                          >
                            <Button onClick={() => this.handleOpenFactory(val)} style={{ height: 'auto' }}>
                              <div>{val}</div>
                              <div>{this.state.showFullIssue}</div>
                            </Button>
                          </Col>
                        </>
                      ))}
                    </Row>
                  </S.Card>
                </S.TablesWrapper>

                <S.TablesWrapper>
                  <S.Card style={{ margin: '15px' }}>
                    <Row>
                      <Col span={3} style={{ display: 'flex', alignItems: 'center', paddingLeft: '15px' }}>
                        <h2>Share function</h2>
                      </Col>
                      <Col span={7}>
                        {this.state.showFullIssue === issueTypes.safety ? (
                          <SafetyLayoutIqc
                            factory={'iqc'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthIqc}
                          ></SafetyLayoutIqc>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.quality ? (
                          <QualityLayoutIqc
                            factory={'iqc'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthIqc}
                          ></QualityLayoutIqc>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.delivery ? (
                          <DeliveryLayoutIqc
                            factory={'iqc'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthIqc}
                          ></DeliveryLayoutIqc>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.productivity ? (
                          <ProductiveLayoutIqc
                            factory={'iqc'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthIqc}
                          ></ProductiveLayoutIqc>
                        ) : null}
                      </Col>
                      <Col span={7}>
                        {this.state.showFullIssue === issueTypes.safety ? (
                          <SafetyLayoutWh
                            factory={'wh'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthWh}
                          ></SafetyLayoutWh>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.quality ? (
                          <QualityLayoutWh
                            factory={'wh'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthWh}
                          ></QualityLayoutWh>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.delivery ? (
                          <DeliveryLayoutWh
                            factory={'wh'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthWh}
                          ></DeliveryLayoutWh>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.productivity ? (
                          <ProductiveLayoutWh
                            factory={'wh'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthWh}
                          ></ProductiveLayoutWh>
                        ) : null}
                      </Col>
                      <Col span={7}>
                        {this.state.showFullIssue === issueTypes.safety ? (
                          <SafetyLayoutFac
                            factory={'fac'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthFac}
                          ></SafetyLayoutFac>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.quality ? (
                          <UtilityLayoutFac
                            factory={'fac'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthFac}
                          ></UtilityLayoutFac>
                        ) : null}
                        {this.state.showFullIssue === issueTypes.productivity ? (
                          <MachineLayoutFac
                            factory={'fac'}
                            oneTypeIssue={true}
                            showIssueInfo={this.showIssueInfo}
                            // lastClickedElement={this.state.lastClickedElement}
                            // lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonth={this.state.dataInMonthFac}
                          ></MachineLayoutFac>
                        ) : null}
                        {/* {this.state.showFullIssue === issueTypes.productivity ? (
                        <OthersLayoutFac
                          factory={'fac'}
                          oneTypeIssue={true}
                          showIssueInfo={this.showIssueInfo}
                          // lastClickedElement={this.state.lastClickedElement}
                          // lastGroupClicked={this.state.lastGroupClicked}
                          dataInMonth={this.state.dataInMonthFac}
                        ></OthersLayoutFac>
                      ) : null} */}
                      </Col>
                    </Row>

                    <Row style={{ marginTop: '25px' }}>
                      <Col span={3}></Col>
                      {listFactoryShareFunction.map((val, key) => (
                        <>
                          <Col
                            key={key}
                            span={7}
                            style={
                              this.state.showFullIssue === issueTypes.productivity
                                ? { paddingLeft: '50px', textAlign: 'center' }
                                : { paddingLeft: '30px', paddingRight: '15px', fontSize: '15.5px', textAlign: 'center' }
                            }
                          >
                            {!(val === 'FACILITY' && this.state.showFullIssue === issueTypes.delivery) && (
                              <Button onClick={() => this.handleOpenFactory(val)} style={{ height: 'auto' }}>
                                <div>{val}</div>
                                <div>{this.state.showFullIssue}</div>
                              </Button>
                            )}
                          </Col>
                        </>
                      ))}
                    </Row>
                  </S.Card>
                </S.TablesWrapper>
                {/* <S.Card style={{ margin: '15px' }}> */}
                <BarAllIssueStatusChart
                  dataPropFac={this.state.dataInMonthFac}
                  dataPropWh={this.state.dataInMonthWh}
                  dataPropInt={this.state.dataInMonthInt}
                  dataPropIqc={this.state.dataInMonthIqc}
                  dataPropCbm={this.state.dataInMonthCbm}
                  dataPropSpa={this.state.dataInMonthSpa}
                  selectedMonth={this.state.filterMonth}
                />
                {/* </S.Card> */}
              </>
            ) : (
              <>
                <Row style={{ marginBottom: '-0.5rem', marginTop: '1.5rem', marginLeft: '1rem' }}>
                  <Col span={24} style={{ marginBottom: '0.5rem' }}>
                    <Row>
                      <Col span={4}>
                        <Sbutton.BtnWrapper>
                          <Sbutton.Btn onClick={() => (window.location = '/')} type="primary" style={{ width: '15vh' }}>
                            {t('common.back')} <ArrowLeftOutlined />
                          </Sbutton.Btn>
                        </Sbutton.BtnWrapper>
                      </Col>
                      <Col span={20}>
                        <H.ProfileColumn $isTwoColumnsLayout={false} style={{ paddingRight: '1rem' }}>
                          <Row align="middle" justify="end" gutter={[10, 10]}>
                            <Col>
                              <Row gutter={[{ xxl: 10 }, { xxl: 10 }]}>
                                <Col>
                                  <HeaderFullscreen />
                                </Col>
                                <Col>
                                  <SettingsDropdown />
                                </Col>
                              </Row>
                            </Col>

                            <Col>
                              <ProfileDropdown />
                            </Col>
                            <Col style={{ marginLeft: 10 }}>
                              <img src={hitachi_logo_inspire} alt="Hitachi" height={60} />
                            </Col>
                          </Row>
                        </H.ProfileColumn>
                      </Col>
                    </Row>
                  </Col>
                  <Col span={24}>
                    <Row>
                      <Sbutton.BtnWrapper>
                        <DatePicker
                          defaultValue={dayjs(this.state.filterMonth)}
                          format={monthFormat}
                          picker="month"
                          onChange={this.onChangeSelectTime}
                          style={{ maxWidth: '125px', minWidth: '125px' }}
                        />
                        <Sbutton.Btn onClick={() => applyFilter()} type="primary">
                          {t('newsFeed.apply')}
                        </Sbutton.Btn>
                      </Sbutton.BtnWrapper>
                    </Row>
                  </Col>
                </Row>
                {this.conditionShowData() ? (
                  <S.TablesWrapper>
                    <S.Card style={{ margin: '15px' }}>
                      <Row>
                        <Col span={6}>
                          <SafetyLayout
                            showIssueInfo={this.showFullSafety}
                            lastClickedElement={this.state.lastClickedElement}
                            lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonthFac={this.state.dataInMonthFac}
                            dataInMonthInt={this.state.dataInMonthInt}
                            dataInMonthIqc={this.state.dataInMonthIqc}
                            dataInMonthCbm={this.state.dataInMonthCbm}
                            dataInMonthWh={this.state.dataInMonthWh}
                            dataInMonthSpa={this.state.dataInMonthSpa}
                            selectedMonth={this.state.selectedMonth}
                          ></SafetyLayout>
                        </Col>
                        <Col span={6}>
                          <QualityLayout
                            showIssueInfo={this.showFullSafety}
                            lastClickedElement={this.state.lastClickedElement}
                            lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonthFac={this.state.dataInMonthFac}
                            dataInMonthInt={this.state.dataInMonthInt}
                            dataInMonthIqc={this.state.dataInMonthIqc}
                            dataInMonthCbm={this.state.dataInMonthCbm}
                            dataInMonthWh={this.state.dataInMonthWh}
                            dataInMonthSpa={this.state.dataInMonthSpa}
                            selectedMonth={this.state.selectedMonth}
                          ></QualityLayout>
                        </Col>
                        <Col span={6}>
                          <DeliveryLayout
                            showIssueInfo={this.showFullSafety}
                            lastClickedElement={this.state.lastClickedElement}
                            lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonthFac={this.state.dataInMonthFac}
                            dataInMonthInt={this.state.dataInMonthInt}
                            dataInMonthIqc={this.state.dataInMonthIqc}
                            dataInMonthCbm={this.state.dataInMonthCbm}
                            dataInMonthWh={this.state.dataInMonthWh}
                            dataInMonthSpa={this.state.dataInMonthSpa}
                            selectedMonth={this.state.selectedMonth}
                          ></DeliveryLayout>
                        </Col>
                        <Col span={6}>
                          <ProductiveLayout
                            showIssueInfo={this.showFullSafety}
                            lastClickedElement={this.state.lastClickedElement}
                            lastGroupClicked={this.state.lastGroupClicked}
                            dataInMonthFac={this.state.dataInMonthFac}
                            dataInMonthInt={this.state.dataInMonthInt}
                            dataInMonthIqc={this.state.dataInMonthIqc}
                            dataInMonthCbm={this.state.dataInMonthCbm}
                            dataInMonthWh={this.state.dataInMonthWh}
                            dataInMonthSpa={this.state.dataInMonthSpa}
                            selectedMonth={this.state.selectedMonth}
                          ></ProductiveLayout>
                        </Col>
                      </Row>

                      <Row style={{ marginTop: '25px' }}>
                        <Col span={6} style={{ paddingLeft: '20px', paddingRight: '15px', fontSize: '15.5px' }}>
                          <p className="issue-color-green">{t('issuepage.safetyGreen')}</p>
                          <p className="issue-color-yellow">{t('issuepage.safetyYellow')}</p>
                          <p className="issue-color-red">{t('issuepage.safetyRed')}</p>
                        </Col>
                        <Col span={6} style={{ paddingLeft: '60px', paddingRight: '10px', fontSize: '15.5px' }}>
                          <p className="issue-color-green">{t('issuepage.qualityGreen')}</p>
                          <p className="issue-color-yellow">{t('issuepage.qualityYellow')}</p>
                          <p className="issue-color-red">{t('issuepage.qualityRed')}</p>
                        </Col>
                        <Col span={6} style={{ paddingLeft: '60px', fontSize: '15.5px' }}>
                          <p className="issue-color-green">{t('issuepage.deliveryGreen')}</p>
                          <p className="issue-color-red">{t('issuepage.deliveryRed')}</p>
                        </Col>
                        <Col span={6} style={{ paddingLeft: '70px', fontSize: '15.5px' }}>
                          <p className="issue-color-green">{t('issuepage.productivityGreen')}</p>
                          <p className="issue-color-yellow">{t('issuepage.productivityYellow')}</p>
                          <p className="issue-color-red">{t('issuepage.productivityRed')}</p>
                        </Col>
                      </Row>
                    </S.Card>
                  </S.TablesWrapper>
                ) : (
                  <></>
                )}

                <S.TablesWrapper>
                  <S.Card style={{ margin: '15px' }}>
                    <Row style={{ marginTop: '15px' }}>
                      <Col span={12} style={{ paddingLeft: '70px', fontSize: '15.5px' }}>
                        <Row>
                          <h2>PLANT</h2>
                        </Row>
                        <Row>
                          <Button style={{ width: '20vw' }} onClick={() => this.handleOpenFactory('SPACER')}>
                            SPACER
                          </Button>
                        </Row>
                        <Row style={{ marginTop: '15px' }}>
                          <Button style={{ width: '20vw' }} onClick={() => this.handleOpenFactory('INTERRUPTER')}>
                            INTERRUPTER
                          </Button>
                        </Row>
                        <Row style={{ marginTop: '15px' }}>
                          <Button style={{ width: '20vw' }} onClick={() => this.handleOpenFactory('CBM')}>
                            CBM
                          </Button>
                        </Row>
                      </Col>
                      <Col span={12} style={{ paddingLeft: '60px', fontSize: '15.5px' }}>
                        <Row>
                          <h2>Share function</h2>
                        </Row>

                        <Row>
                          <Button style={{ width: '20vw' }} onClick={() => this.handleOpenFactory('IQC')}>
                            IQC
                          </Button>
                        </Row>

                        <Row style={{ marginTop: '15px' }}>
                          <Button style={{ width: '20vw' }} onClick={() => this.handleOpenFactory('WARE HOUSE')}>
                            WARE HOUSE
                          </Button>
                        </Row>

                        <Row style={{ marginTop: '15px' }}>
                          <Button style={{ width: '20vw' }} onClick={() => this.handleOpenFactory('FACILITY')}>
                            FACILITY
                          </Button>
                        </Row>
                      </Col>
                    </Row>
                  </S.Card>
                </S.TablesWrapper>
              </>
            )}
          </div>
        </Spin>
        {/* <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            paddingRight: '1rem',
            backgroundColor: 'var(--layout-header-bg-color)',
          }}
        >
          <img src={hitachi_energy_logo} alt="Hitachi Energy" height={40} />
        </div> */}
      </div>
    );
  }
}

export default SQDPAll;
